<template>
    <div class="d-flex justify-content-center mx-2">
        <div class="d-flex flex-column text-center">
            <div
                v-if="position === 'cima'"
                class="d-flex flex-column align-items-center"
            >
                <rkm-icon
                    :color="iconColor"
                    :id="uniqueId('top-plus-icon')"
                    @click.native="!disabledButton ? $emit('click') : null"
                    class="plus-icon"
                    icon="plus-circle"
                />

                <rkm-popover
                    v-if="showPopover"
                    :target="uniqueId('top-plus-icon')"
                    :title="`Dente - ${title}`"
                    placement="top"
                    triggers="hover"
                >
                    <slot name="popover" />
                </rkm-popover>

                <span class="mb-1 title">
                    <strong>{{title}}</strong>
                </span>
            </div>

            <div class="tooth">
                <div class="tooth-container">
                    <button
                        @click="handleFragmentClick('cima')"
                        class="fragment top-tooth"
                        v-bind="handleFragmentProps('cima')"
                    />

                    <button
                        @click="handleFragmentClick('direita')"
                        class="fragment right-tooth"
                        v-bind="handleFragmentProps('direita')"
                    />

                    <button
                        @click="handleFragmentClick('esquerda')"
                        class="fragment left-tooth"
                        v-bind="handleFragmentProps('esquerda')"
                    />

                    <button
                        @click="handleFragmentClick('baixo')"
                        class="fragment bottom-tooth"
                        v-bind="handleFragmentProps('baixo')"
                    />

                    <button
                        @click="handleFragmentClick('centro')"
                        class="fragment middle-tooth"
                        v-bind="handleFragmentProps('centro')"
                    />
                </div>
            </div>

            <div
                v-if="position === 'baixo'"
                class="d-flex flex-column align-items-center"
            >
                <span class="mt-1 title">
                    <strong>{{title}}</strong>
                </span>

                <rkm-icon
                    :color="iconColor"
                    :id="uniqueId('bottom-plus-icon')"
                    @click.native="!disabledButton ? $emit('click') : null"
                    class="plus-icon"
                    icon="plus-circle"
                />

                <rkm-popover
                    v-if="showPopover"
                    :target="uniqueId('bottom-plus-icon')"
                    :title="`Dente - ${title}`"
                    placement="bottom"
                    triggers="hover"
                >
                    <slot name="popover" />
                </rkm-popover>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        handleFragmentProps(position) {
            let props = {}

            if (this.disabledFragment) {
                props.disabled = true
            }

            if (this.fragments[position].isTratado !== null) {
                if (this.fragments[position].isTratado) {
                    props.class = 'treated'
                } else {
                    props.class = 'untreated'
                }
            }

            return props
        },
        handleFragmentClick(position) {
            if (this.fragments[position].isTratado === null) {
                this.fragments[position].isTratado = false
            } else if (this.fragments[position].isTratado === false) {
                this.fragments[position].isTratado = true
            } else {
                this.fragments[position].isTratado = null
            }
        },
    },
    props: {
        disabledButton: {type: Boolean, default: false},
        disabledFragment: {type: Boolean, default: false},
        fragments: {type: Object},
        iconColor: {type: String},
        position: {type: String, default: 'baixo'},
        showPopover: {type: Boolean, default: false},
        title: {type: [Number, String]},
    },
}
</script>

<style scoped>
.tooth {
    background-color: #FFFFFF;
    border-radius: 10%;
    border: 2px solid rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    height: 44px;
    overflow: hidden;
    position: relative;
    width: 44px;
}
.tooth-container {
    height: 80px;
    left: -20px;
    position: absolute;
    top: -20px;
    transform: rotate(45deg);
    width: 80px;
}
.fragment {
    background-color: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.4);
    height: 40px;
    padding: 0px;
    position: absolute;
    width: 40px;
}
.fragment:hover {
    filter: brightness(80%);
}
.fragment:disabled {
    filter: brightness(80%);
}
.top-tooth {
    left: 0px;
    top: 0px;
}
.right-tooth {
    left: 40px;
    top: 0px;
}
.left-tooth {
    left: 0px;
    top: 40px;
}
.bottom-tooth {
    left: 40px;
    top: 40px;
}
.middle-tooth {
    border-radius: 20%;
    border: 2px solid rgba(0, 0, 0, 0.4);
    height: 24px !important;
    left: 28px;
    top: 28px;
    transform: rotate(45deg);
    width: 24px !important;
}
.title {
    font-size: 18px;
}
.plus-icon {
    cursor: pointer;
    font-size: 20px;
}
.treated {
    background-color: var(--primary);
    filter: brightness(120%);
}
.treated:disabled {
    filter: brightness(100%);
}
.untreated {
    background-color: var(--danger);
    filter: brightness(120%);
}
.untreated:disabled {
    filter: brightness(100%);
}
</style>